import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import GalleryLightbox from '../components/GalleryLightbox';
import { companyInfo, openingHours } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function WatchRepairPage() {
  const craftImage = "https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/img-20250925-wa0002-3_4b076ba9.jpg";

  const watchServices = [
    {
      num: "01",
      title: "BATTERISKIFT",
      desc: "Professionelt skift af ur-batteri."
    },
    {
      num: "02",
      title: "GLASUDSKIFTNING & REMME",
      desc: "Montering af nye mineralglas, safirglas samt tilpasning af læderremme og stållænker."
    },
    {
      num: "03",
      title: "FULD URVÆRKSSERVICE",
      desc: "Komplet adskillelse, rensning, smøring og regulering af mekaniske og automatiske urværker."
    },
    {
      num: "04",
      title: "RESERVEDELE & ORIGINALKOMPONENTER",
      desc: "Udskiftning af optrækskroner, aksler og pakninger på mange mærker."
    },
  ];

  return (
    <>
      <Helmet>
        <title>Urereparation & Urservice - Brønshøj Ure & Guld</title>
        <meta
          name="description"
          content="Faguddannet urmager i Brønshøj med over 35 års erfaring. Vi tilbyder batteriskift, trykprøvning, glasudskiftning, remme og fuld urværksservice."
        />
        <meta property="og:title" content="Urereparation & Urservice - Brønshøj Ure & Guld" />
        <meta
          property="og:description"
          content="Faguddannet urmager i Brønshøj med over 35 års erfaring. Vi tilbyder batteriskift, trykprøvning, glasudskiftning, remme og fuld urværksservice."
        />
        <meta
          property="og:image"
          content="https://assets.auxodev.dk/assets/807b5052-bea6-494e-8947-b0c29529a13c/imgi-39-762553405-2193861241393255-5759380788054099571-n.jpg"
        />
      </Helmet>

      {/* Hero Header */}
      <section className="bg-[#0B132B] text-white pt-36 sm:pt-40 lg:pt-56 pb-16 sm:pb-20 lg:pb-24 border-b border-white/10 text-center">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 space-y-5">
          <span className="text-xs uppercase tracking-[0.3em] text-[#B5A897] font-semibold block">
            FAGUDDANNET URMAGER I BRØNSHØJ
          </span>
          <h1 className="font-serif text-3xl sm:text-5xl uppercase tracking-[0.2em] font-normal text-white">
            UREREPARATION & URSERVICE
          </h1>
          <p className="text-xs sm:text-sm text-stone-300 max-w-2xl mx-auto uppercase tracking-widest font-sans leading-relaxed">
            Dine ure kræver løbende pleje for at forblive smukke og gå helt præcist. Vi udfører alle former for urereparationer med høj faglighed og omhu.
          </p>

          <div className="pt-4 flex flex-wrap items-center justify-center gap-4">
            <a
              href={`tel:${companyInfo.phoneRaw}`}
              className="px-8 py-3.5 bg-[#B5A897] text-[#0B132B] hover:bg-white transition-all text-xs tracking-[0.25em] uppercase font-medium rounded-none inline-flex items-center gap-2"
            >
              <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
              RING: {companyInfo.phone}
            </a>
            <a
              href="#serviceomraader"
              className="px-8 py-3.5 border border-[#B5A897] text-[#B5A897] bg-transparent hover:bg-[#B5A897] hover:text-[#0B132B] transition-all text-xs tracking-[0.25em] uppercase font-medium rounded-none"
            >
              SE VORES YDELSER
            </a>
          </div>
        </div>
      </section>

      {/* Main Presentation (2-column layout) */}
      <section className="pt-16 sm:pt-20 pb-0 bg-[#F9F8F6]">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
            
            {/* Left Content Card */}
            <div className="lg:col-span-7 bg-[#F2EFE9] border border-[#E2DDD3] p-8 sm:p-12 space-y-6">
              <div className="w-[1px] h-8 bg-[#B5A897]"></div>
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#B5A897] font-semibold block">
                FAGLIGHED & PRÆCISION
              </span>
              <h2 className="font-serif text-2xl sm:text-3xl font-normal uppercase tracking-[0.15em] text-[#1A1A1A]">
                PRÆCISION OG FAGLIG STOLTHED
              </h2>
              
              <div className="text-xs sm:text-sm text-stone-700 leading-relaxed space-y-4">
                <p>
                  Et godt ur er både en praktisk genstand og ofte en genstand med stor personlig affektionsværdi. Derfor fortjener det den bedste behandling.
                </p>
                <p>
                  Dine ure kræver løbende pleje for at forblive præcise. Til dine ure tilbyder vi alt fra batteriskift og trykprøvning til fuld service af urværket, så det går helt præcist.
                </p>
              </div>

              <div className="pt-2 flex flex-wrap items-center gap-4">
                <a
                  href={`tel:${companyInfo.phoneRaw}`}
                  className="inline-block border border-[#0B132B] text-[#0B132B] bg-transparent hover:bg-[#0B132B] hover:text-white transition-all text-xs tracking-[0.25em] uppercase px-8 py-3.5 rounded-none font-medium"
                >
                  RING: {companyInfo.phone}
                </a>
                <Link
                  to="/brands"
                  className="inline-block border border-[#B5A897] text-[#8C7A68] hover:text-[#0B132B] hover:border-[#0B132B] transition-all text-xs tracking-[0.2em] uppercase px-6 py-3.5 rounded-none font-medium"
                >
                  SE VORES URMÆRKER →
                </Link>
              </div>
            </div>

            {/* Right Photo */}
            <div className="lg:col-span-5 relative">
              <div className="overflow-hidden">
                <img
                  src={imageUrl(craftImage, "width=800,quality=85,format=auto")}
                  alt="Urmager reparation og service i Brønshøj"
                  className="w-full h-[400px] sm:h-[480px] object-cover"
                />
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Services Grid (4 boxes) */}
      <section id="serviceomraader" className="py-12 sm:py-16 bg-[#F9F8F6]">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-[#090e1a] text-white py-14 sm:py-18 lg:py-20 px-6 sm:px-10 lg:px-12 font-sans border border-white/[0.08]">
            <div className="text-center">
              {/* Section Header */}
              <header className="mb-12 lg:mb-14">
                <p className="text-xs font-medium tracking-[0.25em] uppercase text-[#cbb493] mb-3">
                  URMAGER YDELSER
                </p>
                <h2 className="font-serif text-xl sm:text-2xl md:text-3xl lg:text-4xl uppercase tracking-wider text-white max-w-2xl mx-auto leading-snug sm:whitespace-nowrap">
                  VORES SERVICEOMRÅDER FOR URE
                </h2>
                <p className="text-xs md:text-[13px] leading-relaxed text-slate-300 max-w-md mx-auto pt-3">
                  Vi løser både småjusteringer og større urværkssager på vores eget værksted og i butikken.
                </p>
              </header>

              {/* 2x2 Service Cards with generous width and refined details */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
                {watchServices.map((item, idx) => (
                  <article
                    key={idx}
                    className="p-7 sm:p-8 bg-[#0e1526]/80 border border-white hover:border-[#cbb493] transition-all duration-300 flex flex-col justify-between text-left group"
                  >
                    <div>
                      <div className="w-8 h-px bg-[#cbb493] mb-4 group-hover:w-12 transition-all"></div>
                      <h3 className="font-serif text-base sm:text-lg font-normal uppercase tracking-wider text-white mb-2.5">
                        {item.title}
                      </h3>
                      <p className="text-xs sm:text-sm leading-relaxed text-slate-300">
                        {item.desc}
                      </p>
                    </div>
                  </article>
                ))}
              </div>

              {/* Kontakt knapper */}
              <div className="mt-10 sm:mt-12 flex flex-wrap items-center justify-center gap-4">
                <Link
                  to="/kontakt"
                  className="px-8 py-3.5 bg-[#cbb493] text-[#090e1a] hover:bg-white transition-all text-xs tracking-[0.25em] uppercase font-medium rounded-none inline-flex items-center gap-2"
                >
                  <span>KONTAKT OS</span>
                  <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
                </Link>
                <a
                  href={`tel:${companyInfo.phoneRaw}`}
                  className="px-8 py-3.5 border border-[#cbb493] text-[#cbb493] bg-transparent hover:bg-[#cbb493] hover:text-[#090e1a] transition-all text-xs tracking-[0.25em] uppercase font-medium rounded-none inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                  <span>RING: {companyInfo.phone}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
